import React from "react";
import { Container } from "components/common";
import htmlimg from "assets/illustrations/html.png";
import cssimg from "assets/illustrations/css.png";
import jsimg from "assets/illustrations/javascript.png";
import cpluslimg from "assets/illustrations/c++.png";
import javaimg from "assets/illustrations/java.png";
import reactimg from "assets/illustrations/react.jpg";
import sqlimg from "assets/illustrations/sql.jpg";
import dsa from "assets/illustrations/datastru.png";
import plsql from "assets/illustrations/plsql.png";
import solidity from "assets/illustrations/solidity.png";
import nodejs from "assets/illustrations/nodejs.jpg";
import vscode from "assets/illustrations/vscode.png";
import webd from "assets/illustrations/webd.png";
import ganache from "assets/illustrations/ganache.png";
import wire from "assets/illustrations/wire.jpg";
import nmap from "assets/illustrations/nmap.png";
import burp from "assets/illustrations/burp.png";
import meta from "assets/illustrations/meta.png";
import git from "assets/illustrations/git.png";
import block from "assets/illustrations/block.png";
import cyber from "assets/illustrations/cyber.png";
import kali from "assets/illustrations/kalii.jpg";
import net from "assets/illustrations/net.png";
import her from "assets/illustrations/her.png";












import { Wrapper, Details } from "./styles";

export const Skills = () => {
  return (
    <div>
      <Wrapper as={Container} id='skills'>
        <h1><u>Skills :</u></h1>
        <Details as={Container} id='skill_bos'>
          <div className='containers'>

              <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={webd}
                    alt='webd'
                  />
                </div>
                <h4>Web Development</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={cyber}
                    alt='cyber'
                  />
                </div>
                <h4>Cyber Security</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={block}
                    alt='block'
                  />
                </div>
                <h4>Blockchain</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>

               <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img className='skill_icon' width='45' src={dsa} alt='C' />
                </div>
                <h4>Data Structures & Algorithms</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>

         

               <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={cpluslimg}
                    alt='C++'
                  />
                </div>
                <h3>C++</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={javaimg}
                    alt='Java'
                  />
                </div>
                <h4>Java</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    width='45'
                    src={htmlimg}
                    alt='Html'
                    className='skill_icon'
                  />
                </div>
                <h4>HTML </h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>

            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={cssimg}
                    alt='Css'
                  />
                </div>
                <h4>CSS </h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>

           
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={jsimg}
                    alt='JavaScript'
                  />
                </div>
                <h4>JavaScript</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
           

           
            
             <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={sqlimg}
                    alt='react'
                  />
                </div>
                <h4>SQL</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
             <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={plsql}
                    alt='plsql'
                  />
                </div>
                <h4>PL/SQL</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
                <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={solidity}
                    alt='solidity'
                  />
                </div>
                <h4>Solidity</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            

             <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={reactimg}
                    alt='react'
                  />
                </div>
                <h4>React JS</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
              <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={nodejs}
                    alt='nodejs'
                  />
                </div>
                <h4>NODE JS</h4>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>

            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={vscode}
                    alt='vscode'
                  />
                </div>
                <h3>VS CODE</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
              <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={git}
                    alt='git'
                  />
                </div>
                <h3>Git AND Github</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
              <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={net}
                    alt='net'
                  />
                </div>
                <h3>Netlify</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
              <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={her}
                    alt='her'
                  />
                </div>
                <h3>Heroku</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={kali}
                    alt='kali'
                  />
                </div>
                <h3>Kali Linux</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={burp}
                    alt='burp'
                  />
                </div>
                <h3>Burpsuite</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={wire}
                    alt='wire'
                  />
                </div>
                <h3>Wireshark</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={nmap}
                    alt='nmap'
                  />
                </div>
                <h3>NMAP</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
          
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={ganache}
                    alt='ganache'
                  />
                </div>
                <h3>Ganache Cli</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
            <div className='skill_box'>
              <div className='skill_title'>
                <div className='img'>
                  <img
                    className='skill_icon'
                    width='45'
                    src={meta}
                    alt='meta'
                  />
                </div>
                <h3>Metamask</h3>
              </div>
              {/* <p>Lorem ispum</p> */}
            </div>
         
         
              
          </div>
        </Details>
      </Wrapper>
    </div>
  );
};